export function CapricornSettingsCtrl (
  $scope,
  $state,
  $translate,
  workshopAPI,
  sessionObjAPI,
  messages,
  integrations,
  confirm,
  companyApi
) {
  $scope.integrations = integrations;
  $scope.loaded       = true;
  $scope.settings     = sessionObjAPI.company();

  $scope.Company = companyApi;

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Capricorn' })).then(() => {
      return workshopAPI.get('/company_integrations/add_capricorn');
    }).then(() => {
      return sessionObjAPI.refresh();
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Capricorn' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: 'Capricorn' })).then(() => {
      return workshopAPI.get('/company_integrations/remove_capricorn')
    }).then(() => {
      return sessionObjAPI.refresh();
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: 'Capricorn' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function (form) {
    workshopAPI.patch('/company_integrations', $scope.integrations, 'company_integration').then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };
}
